import {
  IPaginationDTO,
  ICriteriaDTO,
  ICriteriaGroupDTO,
  ITeamCriteriaSelectionDTO,
  ICriteriaCountTeamLevelDTO,
} from '@/dtos';
import { generatePagination, get, post } from './apiWrapper';

export const getCriteriaForYearAPI = async (
  yearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: ICriteriaDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const critera = await get<{ data: ICriteriaDTO[]; count: number }>(
    `/years/${yearId}/criteria${pageOptions}`,
  );
  return critera;
};

export const getCriteriaForBranchYearAPI = async (
  branchYearId: string,
  pagination: IPaginationDTO,
): Promise<{ data: ICriteriaGroupDTO[]; count: number }> => {
  pagination.limit = -1;
  const pageOptions = await generatePagination(pagination);

  const critera = await get<{ data: ICriteriaGroupDTO[]; count: number }>(
    `/branchyear/${branchYearId}/criteria${pageOptions}`,
  );
  return critera;
};

export const getCriteriaForCriteriaGroupBranchYearAPI = async (
  branchYearId: string,
  criteriaGroupId: string,
  pagination: IPaginationDTO,
): Promise<{ data: ICriteriaDTO[]; count: number }> => {
  const pageOptions = await generatePagination(pagination);
  const critera = await get<{ data: ICriteriaDTO[]; count: number }>(
    `/branchyear/${branchYearId}/criteriaGroup/${criteriaGroupId}/criteria${pageOptions}`,
  );
  return critera;
};

export const assignTeamsCriteriaAPI = async (
  yearId: string,
  teamId: string,
  selectedCriteria: ITeamCriteriaSelectionDTO[],
): Promise<boolean> => {
  const results = await post<boolean>(
    `/years/${yearId}/teams/${teamId}/criteria`,
    selectedCriteria,
  );

  return results;
};

export const getCriteriaCountForTeamLevelYearAPI = async (
  yearId: string,
  teamLevelId: string,
): Promise<ICriteriaCountTeamLevelDTO> => {
  const critera = await get<ICriteriaCountTeamLevelDTO>(
    `/years/${yearId}/criteria/team-level/${teamLevelId}`,
  );
  return critera;
};

export const getRemainingCriteriaDataAPI = async (
  branchYearId: string,
): Promise<{ groupId: string; count: number }[]> => {
  const critera = await get<{ groupId: string; count: number }[]>(
    `/branchyear/${branchYearId}/criteria-remaining`,
  );
  return critera;
};
